import { render, staticRenderFns } from "./ScreenSidebar.vue?vue&type=template&id=7cdf15e5&scoped=true"
import script from "./ScreenSidebar.vue?vue&type=script&lang=js"
export * from "./ScreenSidebar.vue?vue&type=script&lang=js"
import style0 from "./ScreenSidebar.vue?vue&type=style&index=0&id=7cdf15e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdf15e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cdf15e5')) {
      api.createRecord('7cdf15e5', component.options)
    } else {
      api.reload('7cdf15e5', component.options)
    }
    module.hot.accept("./ScreenSidebar.vue?vue&type=template&id=7cdf15e5&scoped=true", function () {
      api.rerender('7cdf15e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/screen/ScreenSidebar.vue"
export default component.exports